export class InfrastructureRequest {
    public ID: number;
    public HashCode: string;
    public Infra_HashCode: string;
    public InfrastructureID: number;
    public InfrastructureType: string;
    public NoOfInfrastructure: number;
    public InfrastructureSize: number;
    public OtherInfrastructure: string;
    public YearID: number;
}